import {StyleSheet} from 'react-native';

import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: cloudLightest,
  },
  heading: {
    paddingVertical: 10,
  },
  content: {
    backgroundColor: white,
  },
});
